
export const NAV_LINKS = [
  { name: 'Home', href: '/' },
  { name: 'My Trips', href: '/trips' },
];

export const BRAND_INFO = {
  name: "WeTrippy",
  tagline: "Organize Travel Plans",
};
